import { type Team } from '@/features/iam/teams/Team'

export class TeamItemViewModel {
  constructor(public readonly team: Team) {}
}
